/** Angular dependencies  */
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
/** In App dependencies  */
import * as UserDataConfig from '../../config/user-data.config';
import { AppState } from '../../../../store/state/app.state';
import { AnnuitantDoctor, DependantDoctor } from '../../../../model/ngrx/health-records.model';
import * as DepHealthRecordsActions from '../../../../store/actions/dep-health-records.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { QuoteDataCaptureService } from 'src/app/shared/services/api-services/quote-datacapture.service';
import { UtilService } from 'src/app/shared/services/api-services/util.service';
import { AnalyticsService, AuthService, FormValidationsService, SERVICE_END_POINT } from '../../../../shared';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-dependant-health-records',
  templateUrl: './dependant-health-records.component.html',
  styleUrls: ['./dependant-health-records.component.scss']
})


export class DependantHealthRecordsComponent implements OnInit, OnDestroy {


  private depPayload;
  private countryName: string;
  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private countriesList;

  public contentData;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public buttonConfig = this.userInputDetail.buttonConfig;
  public addressLine1CodeConfig = this.userInputDetail.addressLine1Config;
  public addressLine2CodeConfig = this.userInputDetail.addressLine2Config;
  public addressLine3CodeConfig = this.userInputDetail.addressLine3Config;
  public addressLine4CodeConfig = this.userInputDetail.addressLine4Config;
  public postCodeConfig = this.userInputDetail.postCodeConfig;


  public emailTextCodeConfig = this.userInputDetail.emailTextConfig;
  public mobilePhoneCodeConfig = this.userInputDetail.contactNumberConfig;
  public countryConfig = this.userInputDetail.countryConfig;
  protected overseasPostCodeConfig = this.userInputDetail.overseasPostCodeConfig;

  addressSearchEnabled = false;
  showSearchAddress = false;
  overseasCustomer: boolean;
  isOverseasDoctor = false;
  showIsUKDoctorFlag = false;
  dependantHealthRecordsForm: UntypedFormGroup;
  dependantDoctorDetails: DependantDoctor;
  dependantDoctorDetailsStore: Observable<DependantDoctor[]>;
  annuitantDoctorDetails: AnnuitantDoctor;
  annuitantDoctorDetailsStore: Observable<AnnuitantDoctor[]>;
  private depRiskQAnswer;
  CMSData;
  surgeryText: string;
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private _location: Location,
    public el: ElementRef,
    private utilService: UtilService,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private analyticsService: AnalyticsService,
    private router: Router, private authService: AuthService) {
    this.contentData = this.route.snapshot.data.contentData.dependantHealthRecords;
    this.annuitantDoctorDetailsStore = store.select(STORE_VAL.annuitant_doctor_details);
    this.dependantDoctorDetailsStore = store.select(STORE_VAL.dependant_doctor_details);
    this.dependantDoctorDetailsStore.subscribe((val) => {
      if (val) {
        if (val.length > 0) {
          this.dependantDoctorDetails = val[0];
          // this.userFormData();
        } else if (this.dependantHealthRecordsForm && !this.quoteDatacaptureService.checkIfObjEmpty(val)) {
          this.dependantHealthRecordsForm.reset();
        }
      }
    });

    this.annuitantDoctorDetailsStore.subscribe((val) => {
      if (val) {
        if (val.length > 0) {
          this.annuitantDoctorDetails = val[0];
          // this.userFormData();
        } else if (this.dependantHealthRecordsForm) {
          this.dependantHealthRecordsForm.reset();
        }
      }
    });

    this.emailTextCodeConfig.required = false;
  }

  /** Angular lifecycle hooks block  */
  ngOnInit() {
    this.addressSearchEnabled = true;
    this.GetCMSDataServiceMapper();
    this.getCountriesList();
    this.updatingConfigValues();
    this.dependantPayloadMapper();
    //this.payloadMapper();
    this.userFormData();

    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout  = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.dependantHealthRecordsForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  /** End of Angular lifecycle hooks block  */

  userFormData = () => {

    if (this.dependantDoctorDetails && !this.checkProperties(this.dependantDoctorDetails)) {
      if (this.dependantDoctorDetails && this.dependantDoctorDetails.ukAddressIndicator == 'N') {
        this.addressSearchEnabled = false;
      } else if (this.dependantDoctorDetails && this.dependantDoctorDetails.ukAddressIndicator == 'Y') {
        if ((this.dependantDoctorDetails.addressline1 !== '' && this.dependantDoctorDetails.addressline1 !== null) ||
          (this.dependantDoctorDetails.addressline2 !== '' && this.dependantDoctorDetails.addressline2 !== null) ||
          (this.dependantDoctorDetails.addressline3 !== '' && this.dependantDoctorDetails.addressline3 !== null) ||
          (this.dependantDoctorDetails.addressline4 !== '' && this.dependantDoctorDetails.addressline4 !== null) ||
          (this.dependantDoctorDetails.postcode !== '' && this.dependantDoctorDetails.postcode !== null)
        ) {
          this.addressSearchEnabled = false;
        }
      }
      // this.addressSearchEnabled = false; // -> to show address line fields and hide address search field
      this.showSearchAddress = (this.dependantDoctorDetails.addressline1 === this.annuitantDoctorDetails.addressline1 &&
        (this.dependantDoctorDetails.postcode === this.annuitantDoctorDetails.postcode ||
          this.dependantDoctorDetails.countryCode === this.annuitantDoctorDetails.countryCode)) ? false : true; // -> to show address line fields 
      this.showIsUKDoctorFlag = (this.showSearchAddress && this.dependantDoctorDetails.ukAddressIndicator) ? true : false;
      this.isOverseasDoctor = this.dependantDoctorDetails.ukAddressIndicator &&
        this.dependantDoctorDetails.ukAddressIndicator === 'N' ? true : false; // -> to hide/show Country code dropdown
      if (this.showSearchAddress === false) {
        this.dependantHealthRecordsForm = this.fb.group({
          depReportViewReqInd: [this.dependantDoctorDetails.depReportViewReqInd, Validators.required],
          postcode: [this.dependantDoctorDetails.postcode],
          addressline1: [this.dependantDoctorDetails.addressline1],
          addressline2: [this.dependantDoctorDetails.addressline2],
          addressline3: [this.dependantDoctorDetails.addressline3],
          addressline4: [this.dependantDoctorDetails.addressline4],
          countryCode: [this.setCountryName(this.dependantDoctorDetails.countryCode) ? this.setCountryName(this.dependantDoctorDetails.countryCode) : null],
          ukaddressIndicator: [this.dependantDoctorDetails.ukAddressIndicator],
          emailAddress: [this.dependantDoctorDetails.emailAddress],
          mobilePhone: [this.dependantDoctorDetails.contactNumber]
        });
      } else {
        this.dependantHealthRecordsForm = this.fb.group({
          depReportViewReqInd: [this.dependantDoctorDetails.depReportViewReqInd, Validators.required],
          postcode: [this.dependantDoctorDetails.postcode, Validators.required],
          addressline1: [this.dependantDoctorDetails.addressline1],
          addressline2: [this.dependantDoctorDetails.addressline2],
          addressline3: [this.dependantDoctorDetails.addressline3],
          addressline4: [this.dependantDoctorDetails.addressline4],
          countryCode: [this.setCountryName(this.dependantDoctorDetails.countryCode) ? this.setCountryName(this.dependantDoctorDetails.countryCode) : null],
          ukaddressIndicator: [this.dependantDoctorDetails.ukAddressIndicator, Validators.required],
          emailAddress: [this.dependantDoctorDetails.emailAddress],
          mobilePhone: [this.dependantDoctorDetails.contactNumber, Validators.required]
        });
      }
    } else if (this.depPayload) {
      this.dependantHealthRecordsForm = this.fb.group({
        depReportViewReqInd: [null, Validators.required],
        postcode: [this.depPayload.postcode],
        addressline1: [this.depPayload.addressline1],
        addressline2: [this.depPayload.addressline2],
        addressline3: [this.depPayload.addressline3],
        addressline4: [this.depPayload.addressline4],
        countryCode: [this.setCountryName(this.depPayload.countryCode) ? this.setCountryName(this.depPayload.countryCode) : null],
        ukaddressIndicator: [null],
        emailAddress: [this.depPayload.emailAddress],
        mobilePhone: [this.depPayload.contactNumber]
      });
    } else {
      this.dependantHealthRecordsForm = this.fb.group({
        depReportViewReqInd: ['', Validators.required],
        postcode: ['', Validators.required],
        addressline1: ['', Validators.required],
        addressline2: [''],
        addressline3: [''],
        addressline4: [''],
        countryCode: [''],
        ukaddressIndicator: ['', Validators.required],
        emailAddress: [''],
        mobilePhone: ['', Validators.required]
      });
    }

    if (this.dependantDoctorDetails.addressline1 && this.addressLine1CodeConfig.value == "") {
      this.addressLine1CodeConfig.value = this.dependantDoctorDetails.addressline1;
    }

    if (this.dependantDoctorDetails.addressline2 && this.addressLine2CodeConfig.value == "") {
      this.addressLine2CodeConfig.value = this.dependantDoctorDetails.addressline2;
    }

    if (this.dependantDoctorDetails.addressline3 && this.addressLine3CodeConfig.value == "") {
      this.addressLine3CodeConfig.value = this.dependantDoctorDetails.addressline3;
    }

    if (this.dependantDoctorDetails.addressline4 && this.addressLine4CodeConfig.value == "") {
      this.addressLine4CodeConfig.value = this.dependantDoctorDetails.addressline4;
    }

    if (this.dependantDoctorDetails.postcode && this.postCodeConfig.defaultValue == "") {
      this.postCodeConfig.defaultValue = this.dependantDoctorDetails.postcode;
    }

    if (this.dependantDoctorDetails.countryCode) {
      this.dependantHealthRecordsForm.controls['countryCode'].setValue(this.setCountryName(this.dependantDoctorDetails.countryCode));
    }

  }

  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  updatingConfigValues() {

    this.addressLine1CodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.addressline1 ? this.dependantDoctorDetails.addressline1 : null;
    //this.addressLine1CodeConfig.maxlength = null;
    this.addressLine2CodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.addressline2 ? this.dependantDoctorDetails.addressline2 : null;
   // this.addressLine2CodeConfig.maxlength = null;
    this.addressLine3CodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.addressline3 ? this.dependantDoctorDetails.addressline3 : null;
    //this.addressLine3CodeConfig.maxlength = null;
    this.addressLine4CodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.addressline4 ? this.dependantDoctorDetails.addressline4 : null;
   // this.addressLine4CodeConfig.maxlength = null;
    this.postCodeConfig.defaultValue = this.dependantDoctorDetails && this.dependantDoctorDetails.postcode ? this.dependantDoctorDetails.postcode : null;
    this.emailTextCodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.emailAddress ? this.dependantDoctorDetails.emailAddress : null;
    this.mobilePhoneCodeConfig.value = this.dependantDoctorDetails && this.dependantDoctorDetails.contactNumber ? this.dependantDoctorDetails.contactNumber : null;
    this.countryName = this.dependantDoctorDetails && this.dependantDoctorDetails.countryCode ? this.setCountryName(this.dependantDoctorDetails.countryCode) : null;
    let val = this.dependantDoctorDetails && this.dependantDoctorDetails.depReportViewReqInd ? this.dependantDoctorDetails.depReportViewReqInd : null;
    this.toggleRiskQuestions(val);
  }

  onToggleAddressSearch() {
    this.showSearchAddress = !this.showSearchAddress;
  }
  onToggleUKDoctorAddress() {
    this.showIsUKDoctorFlag = !this.showIsUKDoctorFlag;
    if (!this.showIsUKDoctorFlag) {
      this.dependantHealthRecordsForm.get('ukaddressIndicator').setValue('');
      this.addressSearchEnabled = false;
      this.showSearchAddress = false;
    }
  }

  getCountriesList() {
    this.utilService.getCountryNames().subscribe(data => {
      if (data) {
        this.countriesList = data;
        this.countryName = (this.dependantDoctorDetails && this.dependantDoctorDetails.countryCode) ?
          this.setCountryName(this.dependantDoctorDetails.countryCode) : null;
      }
    });
  }
  onSelectedAddress(formattedAddress) {
    this.addressLine1CodeConfig.value = (formattedAddress[0]['addressLine1'] && (formattedAddress[0]['addressLine1']).length > 35) ? (formattedAddress[0]['addressLine1']).substr(0,35) : formattedAddress[0]['addressLine1'];
    this.addressLine2CodeConfig.value = (formattedAddress[1]['addressLine2'] && (formattedAddress[1]['addressLine2']).length > 35) ?(formattedAddress[1]['addressLine2']).substr(0,35) :  formattedAddress[1]['addressLine2'];
    this.addressLine3CodeConfig.value = (formattedAddress[2]['addressLine3'] && (formattedAddress[2]['addressLine3']).length > 35) ? (formattedAddress[2]['addressLine3']).substr(0,35) : formattedAddress[2]['addressLine3'];
    this.addressLine4CodeConfig.value = (formattedAddress[3]['locality'] && (formattedAddress[3]['locality']).length > 35 ) ? (formattedAddress[3]['locality']).substr(0,35) : formattedAddress[3]['locality'];
    this.postCodeConfig.defaultValue = formattedAddress[5]['postalCode'];
    this.addressSearchEnabled = false;
    if (formattedAddress[6]['country'] === 'UNITED KINGDOM') {
      this.isOverseasDoctor = false;
    } else {
      this.isOverseasDoctor = true;
    }
    // this.payloadMapper();
  }
  toggleContainer(data) {

    if (data === 'Y') {
      this.onToggleAddressSearch();
      this.dependantHealthRecordsForm.get('ukaddressIndicator').setValue('Y');
      this.dependantHealthRecordsForm.controls['postcode'].setValidators([Validators.required]);
      this.overseasCustomer = false;
      this.addressSearchEnabled = true;
      this.isOverseasDoctor = false;
      this.showSearchAddress = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.dependantHealthRecordsForm.controls['addressline2'].clearValidators();
      this.addressLine2CodeConfig.required = false;
    } else {
      this.dependantHealthRecordsForm.get('ukaddressIndicator').setValue('N');
      // remove validation
      this.dependantHealthRecordsForm.controls['postcode'].clearValidators();
      this.dependantHealthRecordsForm.get('postcode').setValue('');
      this.overseasCustomer = true;
      this.addressSearchEnabled = false;
      this.isOverseasDoctor = true;
      this.showSearchAddress = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.dependantHealthRecordsForm.controls['addressline2'].setValidators(Validators.required);
      this.addressLine2CodeConfig.required = true;
    }
  }
  onManualClick() {
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.addressLine1CodeConfig.value = '';
    this.addressLine2CodeConfig.value = '';
    this.addressLine3CodeConfig.value = '';
    this.addressLine4CodeConfig.value = '';
    this.postCodeConfig.defaultValue = '';
    this.emailTextCodeConfig.value = '';
    this.mobilePhoneCodeConfig.value = '';
    this.isOverseasDoctor = false;

  }
  onAddressSearchClick() {
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.isOverseasDoctor = false;
  }

  OnBackClick() {
    // adding form to store
    this.payloadMapper();
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new DepHealthRecordsActions.AddDepHealthRecords(this.depPayload));
  }

  /** Creates the depPayload to store and POST it to the service */
  payloadMapper() {
    this.depPayload = new DependantDoctor();

    // if (this.showSearchAddress === false) {
    //   this.depPayload.addressline1 = this.annuitantDoctorDetails.addressline1 ?  this.annuitantDoctorDetails.addressline1 : null;
    //   this.depPayload.addressline2 = this.annuitantDoctorDetails.addressline2 ?  this.annuitantDoctorDetails.addressline2 : null;
    //   this.depPayload.addressline3 = this.annuitantDoctorDetails.addressline3 ?  this.annuitantDoctorDetails.addressline3 : null;
    //   this.depPayload.addressline4 = this.annuitantDoctorDetails.addressline4 ?  this.annuitantDoctorDetails.addressline4 : null;
    //   this.depPayload.postcode = this.annuitantDoctorDetails.postcode ? this.annuitantDoctorDetails.postcode : null;
    //   this.depPayload.countryCode = this.annuitantDoctorDetails.countryCode ?  this.annuitantDoctorDetails.countryCode : null;
    //   this.depPayload.emailAddress = this.annuitantDoctorDetails.emailAddress ? this.annuitantDoctorDetails.emailAddress : null;
    //   this.depPayload.contactNumber = this.annuitantDoctorDetails.contactNumber ? this.annuitantDoctorDetails.contactNumber : null;
    //   this.depPayload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
    //   } else {
    //   this.depPayload.addressline1 = this.addressLine1CodeConfig.value ?  this.addressLine1CodeConfig.value : null;
    //   this.depPayload.addressline2 = this.addressLine2CodeConfig.value ?  this.addressLine2CodeConfig.value : null;
    //   this.depPayload.addressline3 = this.addressLine3CodeConfig.value ? this.addressLine3CodeConfig.value : null;
    //   this.depPayload.addressline4 = this.addressLine4CodeConfig.value ? this.addressLine4CodeConfig.value : null;
    //   this.depPayload.postcode = this.postCodeConfig.defaultValue ? this.postCodeConfig.defaultValue : null;
    //   this.depPayload.countryCode = this.setCountryCode() ?  this.setCountryCode() : null;
    //   this.depPayload.emailAddress = this.emailTextCodeConfig.value ? this.emailTextCodeConfig.value : null;
    //   this.depPayload.contactNumber = this.mobilePhoneCodeConfig.value ? this.mobilePhoneCodeConfig.value : null;
    //   this.depPayload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
    //   }

    if (this.showSearchAddress === false) {
      // tslint:disable-next-line: max-line-length
      this.depPayload.addressline1 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline1) ? this.annuitantDoctorDetails.addressline1 : null;
      // tslint:disable-next-line: max-line-length
      this.depPayload.addressline2 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline2) ? this.annuitantDoctorDetails.addressline2 : null;
      // tslint:disable-next-line: max-line-length
      this.depPayload.addressline3 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline3) ? this.annuitantDoctorDetails.addressline3 : null;
      // tslint:disable-next-line: max-line-length
      this.depPayload.addressline4 = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.addressline4) ? this.annuitantDoctorDetails.addressline4 : null;
      this.depPayload.postcode = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.postcode) ? this.annuitantDoctorDetails.postcode : null;
      this.depPayload.countryCode = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.countryCode) ? this.annuitantDoctorDetails.countryCode : null;
      this.depPayload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
      // tslint:disable-next-line: max-line-length
      this.depPayload.emailAddress = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.emailAddress) ? this.annuitantDoctorDetails.emailAddress : null;
      // tslint:disable-next-line: max-line-length
      this.depPayload.contactNumber = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.contactNumber) ? this.annuitantDoctorDetails.contactNumber : null;
      this.depPayload.ukAddressIndicator = (this.annuitantDoctorDetails && this.annuitantDoctorDetails.ukAddressIndicator) ? this.annuitantDoctorDetails.ukAddressIndicator : null;
    } else {
      this.depPayload.addressline1 = this.addressLine1CodeConfig.value ? this.addressLine1CodeConfig.value : null;
      this.depPayload.addressline2 = this.addressLine2CodeConfig.value ? this.addressLine2CodeConfig.value : null;
      this.depPayload.addressline3 = this.addressLine3CodeConfig.value ? this.addressLine3CodeConfig.value : null;
      this.depPayload.addressline4 = this.addressLine4CodeConfig.value ? this.addressLine4CodeConfig.value : null;
      this.depPayload.postcode = this.postCodeConfig.defaultValue ? this.postCodeConfig.defaultValue : null;
      this.depPayload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
      this.depPayload.emailAddress = this.emailTextCodeConfig.value ? this.emailTextCodeConfig.value : null;
      this.depPayload.contactNumber = this.mobilePhoneCodeConfig.value ? this.mobilePhoneCodeConfig.value : null;
      this.depPayload.ukAddressIndicator = this.overseasCustomer ? 'N' : 'Y';
      this.depPayload.countryCode = this.getCountryCodeVal(this.dependantHealthRecordsForm.value.countryCode) ? this.getCountryCodeVal(this.dependantHealthRecordsForm.value.countryCode) : null;
    }
  }

  dependantPayloadMapper() {
    this.depPayload = new DependantDoctor();
    this.depPayload.addressLine1 = (this.dependantDoctorDetails && this.dependantDoctorDetails.addressline1) ? this.dependantDoctorDetails.addressline1 : null;
    this.depPayload.addressLine2 = (this.dependantDoctorDetails && this.dependantDoctorDetails.addressline2) ? this.dependantDoctorDetails.addressline2 : null;
    this.depPayload.addressLine3 = (this.dependantDoctorDetails && this.dependantDoctorDetails.addressline3) ? this.dependantDoctorDetails.addressline3 : null;
    this.depPayload.addressLine4 = (this.dependantDoctorDetails && this.dependantDoctorDetails.addressline4) ? this.dependantDoctorDetails.addressline4 : null;
    this.depPayload.postcode = (this.dependantDoctorDetails && this.dependantDoctorDetails.postcode) ? this.dependantDoctorDetails.postcode : null;
    this.depPayload.depReportViewReqInd = this.getRiskQAnswer() ? this.getRiskQAnswer() : null;
    this.depPayload.emailAddress = (this.dependantDoctorDetails && this.dependantDoctorDetails.emailAddress) ? this.dependantDoctorDetails.emailAddress : null;
    this.depPayload.contactNumber = (this.dependantDoctorDetails && this.dependantDoctorDetails.contactNumber) ? this.dependantDoctorDetails.contactNumber : null;
    this.depPayload.ukAddressIndicator = (this.dependantDoctorDetails && this.dependantDoctorDetails.ukAddressIndicator)
      ? this.dependantDoctorDetails.ukAddressIndicator : null;
    this.countryName = this.depPayload.countryCode = (this.dependantDoctorDetails && this.dependantDoctorDetails.countryCode) ? this.setCountryName(this.dependantDoctorDetails.countryCode) : null;
  }

  backtoPrevious() {
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new DepHealthRecordsActions.AddDepHealthRecords(this.depPayload));
    this._location.back();
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.payloadMapper();
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveFormValues() {
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new DepHealthRecordsActions.AddDepHealthRecords(this.depPayload));
  }

  getCountryCodeVal(value) {
    let countryCode: string = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryCodeValue = this.countriesList.filter(val => val['description'] == value);
      countryCode = (countryCodeValue && countryCodeValue[0] && countryCodeValue[0]['key']) ? countryCodeValue[0]['key'] : '';
    }
    return countryCode;
  }
  setCountryName(value) {
    let countryName: string = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryNameValue = this.countriesList.filter(val => val['key'] == value);
      countryName = (countryNameValue && countryNameValue[0] && countryNameValue[0]['description']) ? countryNameValue[0]['description'] : '';
    }
    return countryName;
  }

  // toggleRiskQuestions(control) {
  //   this.depPayload.depReportViewReqInd = control;
  // }

  gotoNext() {
    this.payloadMapper();
    this.saveFormValues();
    if (this.dependantHealthRecordsForm.valid) {
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        //console.log("Response from backend", res);
        this.dependantHealthRecordsForm.reset();
        // TODO: as per DTC-292 , this needs to be navigated to the Pension savings screen, not payment details

        this.router.navigate(['apply/your-pension-savings']);

      });
    } else {
      //console.log('Not Valid', this.dependantHealthRecordsForm);
      FormValidationsService.validateAllFormFields(this.dependantHealthRecordsForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  toggleRiskQuestions(control) {
    this.depRiskQAnswer = control;
  }
  getRiskQAnswer() {
    return this.depRiskQAnswer;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_DependantDoctorsDetailsApply;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.sameAsMineText = this.CMSData.string_SameAsMineLabel;
        this.contentData.header = this.CMSData.string_DependantDoctorsDetailsTitle;
        this.contentData.introduction = this.CMSData.string_DependantDoctorsDetailsSubtitle;
        this.surgeryText = this.CMSData.commonBlock.string_SurgeryAddress;
        this.contentData.sensitiveDataText = this.CMSData.html_SensitiveDataIntroductionDependant;
      }
    });
  }
  /** End of code block for CMS */
}
